{
  "appName": "AirPlx",
  "logoAlt": "Logo de AirPlx",
  "errors": {
    "authRequired": "Autenticación de usuario requerida",
    "loginAgain": "Por favor, inicia sesión de nuevo para aceptar invitaciones",
    "serviceUnavailable": "Servicio no disponible",
    "serviceTemporarilyUnavailable": "Servicio temporalmente no disponible. Intenta de nuevo.",
    "emailRequired": "Correo requerido",
    "emailRequiredValidation": "El correo del usuario es obligatorio para validar la invitación",
    "inviteInvalid": "La invitación ya no es válida o ya fue utilizada",
    "invalidFBOInfo": "Información de FBO no válida en la invitación",
    "inviteCouldNotBeClaimed": "No se pudo reclamar la invitación",
    "acceptFailed": "No se pudo aceptar la invitación"
  },
  "inviteStatus": {
    "pending": "Pendiente",
    "accepting": "Aceptando...",
    "tryAgain": "Reintentar",
    "accept": "Aceptar"
  }
}
